import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SharedService } from "../../services/shared.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email: string = "";
  password: string = "";
  errors: string[] = [];
  errorResponse: string = '';

  constructor(
    public auth: AuthService, 
    private router: Router,
    private shared: SharedService
  ) {}

  ngOnInit() {
  }

  canLogin() {
    return this.email !== '' && this.password !== '';
  }

  validEmail(): boolean {
    if (this.email === '') return false;

    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(this.email);
  }

  login() {
    this.errors = [];
    if (this.validEmail() === false) this.errors.push('invalid-email');

    if (this.errors.length > 0) return false;

    this.auth.toggleSpinner(true);
    this.errorResponse = '';

    this.auth.emailSignIn({
      email: this.email,
      password: this.password
    })
    .then(() => {
      this.auth.toggleSpinner(false);
      this.auth.getUser().then(response => {
        this.auth.setUser(response)
        if (response.role === AuthService.VTUBER_ROLE && !response.status) {
          this.router.navigate(['/vtuber/support']);
        } else {
          if (response.role === AuthService.USER_ROLE && this.shared.getCookie(SharedService.CURRENT_VTUBER)) {
            this.router.navigate(['/card/pay']);
            return;
          }
          this.router.navigate(['/rooms']);
        }
      });

    })
    .catch(error => {
      this.auth.toggleSpinner(false);
      this.errorResponse = 'パスワードが無効であるか、ユーザーにパスワードがありません。';
    })
  }

  googleSignIn() {
    this.auth.googleSignIn()
    .then((response) => {
      this.handleSocialSignInResponse(response)
    })
    .catch(error => {
      this.errorResponse = "既に登録されているメール アドレスです。別のログイン方法をお試しください。"
    })
  }

  handleSocialSignInResponse(response) {
    if (response.additionalUserInfo.isNewUser) {
      this.errorResponse = 'ユーザーはまだ登録されていません'
      this.auth.signOutWithoutRedirect();
    } else {
      this.auth.getUser().then(res => {
        if (res === undefined) {
          this.errorResponse = 'ユーザーはまだ登録されていません'
          this.auth.signOutWithoutRedirect();
        } else {
          this.auth.setUser(res)
          if (res.role === AuthService.VTUBER_ROLE && !res.status) {
            this.router.navigate(['/vtuber/support']);
          } else {
            if (res.role === AuthService.USER_ROLE && this.shared.getCookie(SharedService.CURRENT_VTUBER)) {
              this.router.navigate(['/card/pay']);
              return;
            }
            this.router.navigate(['/rooms']);
          }
        }
      });
    }
  }

  twitterSignIn() {
    this.auth.twitterSignIn()
    .then((response) => {
      this.handleSocialSignInResponse(response)
    })
    .catch(error => {
      this.errorResponse = "既に登録されているメール アドレスです。別のログイン方法をお試しください。"
    })
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }
}
